import { PropsWithChildren } from "react"

import { SurveyResultsStorage } from "../NewClientSurvey/common/utils/SurveyResultsStorage"

import { Psychologist } from "utils/interfaces"
import { TherapyRequestLookups } from "modules/PsyCommon/components"
import { SurveyResultsPage } from "modules/SelectionOfPsychologists/SurveyResultsPage"
import { numberOfPsychologistsAcc } from "utils/infrastructure/wording-utils"
import { Cards } from "components/Cards"

export function formatText(number: number): string {
    return `Подобрали вам ${number} ${numberOfPsychologistsAcc(number)}`
}

interface Props {
    profiles: Psychologist[]
    showPsysStory?: number
}

export function SelectionOfPsychologists({
    profiles,
    showPsysStory,
    children,
}: PropsWithChildren<Props>) {
    const storage = SurveyResultsStorage.extraData
    return (
        <SurveyResultsPage
            header={formatText(profiles.length)}
            body={
                <>
                    {children}
                    {storage && storage.lookups && storage.lookups.length > 0 && (
                        <TherapyRequestLookups
                            className="has-border"
                            headline={<>О&nbsp;чем можно поговорить с&nbsp;психологом</>}
                            lookups={storage.lookups}
                        />
                    )}
                    <Cards className="mt-5" profiles={profiles} showPsysStory={showPsysStory} />
                </>
            }
        />
    )
}
